import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import MainLayout from './components/MainLayout';
import DashboardPage from './pages/DashboardPage';
import CalendarPage from './pages/CalendarPage';
import BookingListPage from './pages/BookingListPage';
import BookingViewPage from './pages/BookingViewPage';
import BookingEditPage from './pages/BookingEditPage';
import CreateBookingPage from './pages/CreateBookingPage';
import ReportsPage from './pages/ReportsPage';
import ArchivePage from './pages/ArchivePage';
import AdminConfigPage from './pages/AdminConfigPage';
import UserViewPage from './pages/UserViewPage';
import UserEditPage from './pages/UserEditPage';
import UserCreatePage from './pages/UserCreatePage';
import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import './styles.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route element={<ProtectedRoute />}>
            <Route element={<MainLayout />}>
              <Route path="/" element={<Navigate to="dashboard" replace />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/calendar" element={<CalendarPage />} />
              <Route path="/bookings" element={<BookingListPage />} />
              <Route path="/bookings/view/:bookingId" element={<BookingViewPage />} />
              <Route path="/bookings/edit/:bookingId" element={<BookingEditPage />} />
              <Route path="/create" element={<CreateBookingPage />} />
              <Route path="/reports" element={<ReportsPage />} />
              <Route path="/archive" element={<ArchivePage />} />
            </Route>
          </Route>
          <Route element={<ProtectedRoute allowedRoles={['ADMIN']} />}>
            <Route element={<MainLayout />}>
              <Route path="/admin" element={<AdminConfigPage />} />
              <Route path="/admin/users/create" element={<UserCreatePage />} />
              <Route path="/admin/users/view/:userId" element={<UserViewPage />} />
              <Route path="/admin/users/edit/:userId" element={<UserEditPage />} />
            </Route>
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
